<template>
  <div style="padding-top: 20px" class="policyDtl plr15">
    <div class="policyTitle mt5">{{ data.name }}</div>
    <div class="mt4 tips">{{ tips }}</div>
    <div
      class="mt15"
      style="word-wrap: break-word"
      v-html="data.policyDetail"
    ></div>
    <div class="s_tip bgfff">
      {{
        data.defaultWord || "本系统展示的政策内容仅供参考，具体以官方解释为准。"
      }}
    </div>
    <div class="s_foot_btn bgfff">
      <div
        v-if="data.url && data.url != ''"
        @click="copyUrl(data.url)"
        class="btn mr15"
        style="color:#fff"
      >
        政策办事指南
      </div>
      <div
        class="btn"
        style="color: #fff"
        v-if="data.annex"
        @click="copyAnnex(data.annex)"
      >
        相关附件下载
      </div>
    </div>
    <!-- 查看更多蒙版 -->
    <div
      class="s_model"
      @touchmove.prevent
      @mousewheel.prevent
      v-if="!isShow && bodyHeight > 380"
    >
      <div class="model_box">
        <div class="watch_more" @click="toMore">
          <div class="content">
            <div class="mr2">查看详情</div>
            <img class="" src="../images/查看详情icon.svg" alt="" />
          </div>
        </div>
        <div class="s_tip bgfff">
          {{
            data.defaultWord ||
              "本系统展示的政策内容仅供参考，具体以官方解释为准。"
          }}
        </div>
        <div class="s_foot_btn bgfff">
          <div
            v-if="data.url && data.url != ''"
            @click="copyUrl(data.url)"
            class="btn mr15"
            style="color: #000;backgroundColor: #fff"
          >
            政策办事指南
          </div>
          <div
            class="btn"
            style="color: #000;backgroundColor: #fff"
            v-if="data.annex && data.annex != ''"
            @click="copyAnnex(data.annex)"
          >
            相关附件下载
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../http/env";
import utils from "../utils/index";
export default {
  data() {
    return {
      id: "",
      data: {},
      tips: "",
      isShow: false,
      bodyHeight: 0
    };
  },
  watch: {
    id(val) {}
  },
  methods: {
    getDtl(id) {
      this.$http.home
        .getPolicyDtl({
          id
        })
        .then(res => {
          let tipsList = [];
          if (res.data.classificationList) {
            res.data.classificationList.forEach((item, index) => {
              tipsList.push(item.classification);
            });
            this.tips = tipsList.join(",");
          } else {
            this.tips = "";
          }
          this.data = res.data;
        });
    },
    toMore() {
      this.isShow = true;
    },
    // 政策指南
    copyUrl(url) {
      this.$toast({
        type: "html",
        message: "办事指南链接已复制</br>可在浏览器中打开查看"
      });
      utils.copyUrl(url);
    },
    // 相关附件
    copyAnnex(annex) {
      this.$toast({
        type: "html",
        message: "附件下载地址已复制</br>可在浏览器中打开下载"
      });
      utils.copyUrl(`${env.baseURL}/upload/annex/${annex}`);
    }
  },
  created() {
    let id = this.$route.params.id;
    if (id) {
      this.getDtl(id);
    }
  },
  updated() {
    this.bodyHeight = document.body.scrollHeight;
  }
};
</script>
<style lang="less" scoped>
.policyDtl {
  .policyTitle {
    height: 44px;
    font-size: 16px;
    font-weight: 600;
    color: #515359;
    line-height: 22px;
  }
  .tips {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #797d7b;
    line-height: 20px;
  }
  .s_model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    .model_box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #eee;
    }
    .watch_more {
      height: 72px;
      font-size: 14px;
      color: #6d90e2;
      position: relative;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 100%
      );
      .content {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.5);
        padding: 10px 0;
      }
    }
  }
  .s_tip {
    text-align: center;
    height: 17px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.25);
    line-height: 17px;
    padding: 20px 0;
    border-top: 1px dashed rgb(207, 207, 207);
    // background-color: #fff;
  }
  .s_foot_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 15px;
    margin-top: -1px;
  }
  .btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #000;
    border-radius: 24px;
    border: 1px solid #e1e4eb;
    font-size: 12px;
    mix-blend-mode: normal;
  }
}
/deep/ .van-toast {
  color: red !important;
}
.bgfff {
  // background-color: rgba(93, 121, 219, 0.7);
  // background-color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/view/policyDetail.vue